import { configureStore } from '@reduxjs/toolkit'
import { loadingActionReducer } from './reducer'
import {
  LAYOUT,
  THOP_NOTIFICATION_MESSAGES_ADD,
  STATUS_UPDATE_COUNT,
  IPD_DATA_UPDATE_COUNT,
  IPD_UPDATE_MESSAGE_LOCATION,
  DEVICE_LIST,
  SELECTED_DEVICE,
  SELECTED_DEVICE_INDEX,
  IS_DEVICE_CLICKED,
  PRORITHM_WEBSOCKET_MESSAGE,
  PRORITHM_WEBSOCKET_COUNT,
  PRORITHM_WEBSOCKET_CONNECTION_STATUS,
  PRORITHM_NOTIFICATIONS_ADD,
  PRORITHM_NOTIFICATIONS_REMOVE,
  PRORITHM_NOTIFICATIONS_MARK_READ,
  SELECTED_CATEGORY,
} from './actions'
import {
  createStateSyncMiddleware,
  initMessageListener,
} from 'redux-state-sync'

const reduxStateSyncConfig = {
  blacklist: [
    LAYOUT,
    THOP_NOTIFICATION_MESSAGES_ADD,
    STATUS_UPDATE_COUNT,
    IPD_DATA_UPDATE_COUNT,
    IPD_UPDATE_MESSAGE_LOCATION,
    DEVICE_LIST,
    SELECTED_DEVICE,
    SELECTED_DEVICE_INDEX,
    IS_DEVICE_CLICKED,
    SELECTED_CATEGORY,
    PRORITHM_WEBSOCKET_MESSAGE,
    PRORITHM_WEBSOCKET_COUNT,
    PRORITHM_WEBSOCKET_CONNECTION_STATUS,
    PRORITHM_NOTIFICATIONS_ADD,
    PRORITHM_NOTIFICATIONS_REMOVE,
    PRORITHM_NOTIFICATIONS_MARK_READ,
  ],
}

const stateSyncMiddleware = createStateSyncMiddleware(reduxStateSyncConfig)

const store = configureStore({
  reducer: loadingActionReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      stateSyncMiddleware
    ),
})

initMessageListener(store)

export { store }
